import * as Notifications from 'expo-notifications';

import { fromPromise } from 'xstate5';

import type { PushNotificationPermissionStatus } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getPushNotificationPermissionStatusActor =
  fromPromise<PushNotificationPermissionStatus>(async () => Notifications.getPermissionsAsync());
